export default "__VITE_ASSET__a80f1d79__"